<template>
  <div class="footer">
    <div class="footer-content">
      <div class="contact-info">
        <div class="company-name">友丰生态</div>
        <div class="phone-24">24小时服务热线</div>
        <div class="phone-no">400-931-3919</div>
      </div>
      <img class="qrcode" src="@/assets/images/qrcode.png" />
      <!-- <div class="icp-text">粤ICP备17095822号-1</div> -->
      <div class="icp-text"></div>
      <div class="more-info">
        <p>广东友丰油茶科技有限公司</p>
        <p>总部地址：韶关市浈江区犁市镇梅村铁路林场</p>
        <p>营销中心：韶关市浈江区碧桂园凤凰城商业广场第107商铺</p>
      </div>
    </div>
    <el-backtop>
      <img src="@/assets/images/backtotop.png" class="back-top" />
    </el-backtop>
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/color.scss";
.footer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #222222;
  .footer-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    // padding-top: 40px;
    padding-bottom: 15px;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    .contact-info {
      .company-name {
        line-height: 40px;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
        margin-bottom: 9px;
      }
      .phone-24 {
        line-height: 26px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-bottom: 15px;
      }
      .phone-no {
        line-height: 26px;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: $primary-color;
      }
    }
    .qrcode {
      width: 98px;
      height: 98px;
    }
    .icp-text {
      line-height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
    .more-info {
      line-height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      p {
        margin-bottom: 7px;
        &:last-child {
          margin: 0;
        }
      }
    }
  }
}
.back-top {
  width: 50px;
  height: 50px;
}
</style>